import { connect } from 'react-redux';
import * as Selectors from 'APP_ROOT/data/identities/selectors';
import ProfileImage from './ProfileImage';

const mapStateToProps = (state, ownProps) => {
    const { identityId, ...rest } = ownProps;
    const identity = Selectors.identity(state, identityId) || {};
    return {
        ...rest,
        loading: Selectors.loading(state, identityId),
        imageUrl: identity.profileImageUrl,
    };
};

export default connect(mapStateToProps)(ProfileImage);
